var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsProvider, AnalyticsTrigger, Button, Grid, GridColumn, Heading, Notice, Separator, Text } from 'telia-front-react';
import Captcha from './Captcha';
import Fieldset from './Fieldset';
import SubmitButton from './SubmitButton';
import { default as FieldValidationErrorNotice } from './FieldValidationErrorNotice';
let Form = (() => {
    let _classDecorators = [observer];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = React.Component;
    var Form = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "captchaRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: React.createRef()
            });
            Object.defineProperty(this, "handleFormSubmit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: async (event) => {
                    var _a, _b;
                    event.preventDefault();
                    const token = await ((_b = (_a = this.captchaRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getCaptchaAsync());
                    this.props.setCaptcha(token);
                    if (this.props.submit) {
                        this.props.submit();
                    }
                }
            });
        }
        get title() {
            return this.props.showTitle ? this.props.form.title : null;
        }
        get description() {
            return this.props.showDescription ? this.props.form.description : null;
        }
        getSectionFields(section) {
            const { fields } = this.props.form;
            return fields.filter((field) => section.fieldIds.includes(field.id));
        }
        getFieldsWithoutSection() {
            const { form, sections } = this.props;
            const sectionedFieldIds = sections.reduce((result, section) => {
                return result.concat(section.fieldIds);
            }, []);
            return form.fields.filter((field) => !sectionedFieldIds.includes(field.id));
        }
        renderHeader() {
            if (!this.title && !this.description) {
                return null;
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "text text-center" },
                    this.title && React.createElement(Heading, { element: "h2" }, this.title),
                    this.description && React.createElement(Heading, { element: "h4" }, this.description)),
                React.createElement(Separator, { spacing: "small", color: "invisible" })));
        }
        renderFailureNotice() {
            if (!this.props.submitFailed) {
                return null;
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(Notice, { type: "error" }, this.props.translateStore.translate('submit.failure')),
                React.createElement(Separator, { spacing: "small", color: "invisible" })));
        }
        renderSection(section, index) {
            const { form, onChangeCallback } = this.props;
            return (React.createElement(GridColumn, { width: section.colWidths, key: index },
                React.createElement(Text, null,
                    React.createElement(Fieldset, { cssClass: form.cssClass, fields: this.getSectionFields(section), callback: onChangeCallback }))));
        }
        renderRemainingFields() {
            const { form, onChangeCallback } = this.props;
            return (React.createElement(GridColumn, null,
                React.createElement(Text, null,
                    React.createElement(Fieldset, { cssClass: form.cssClass, fields: this.getFieldsWithoutSection(), callback: onChangeCallback }))));
        }
        renderFields() {
            const { form, onChangeCallback, sections } = this.props;
            if (!sections) {
                return React.createElement(Fieldset, { cssClass: form.cssClass, fields: form.fields, callback: onChangeCallback });
            }
            return (React.createElement(Grid, null,
                sections.map((section, index) => this.renderSection(section, index)),
                this.renderRemainingFields()));
        }
        renderButtons() {
            const { form, submitting, backButtonProps, buttonGridProps, buttonGridColumnProps, submitButtonProps, infoPdfButtonProps } = this.props;
            return (React.createElement(React.Fragment, null,
                (infoPdfButtonProps === null || infoPdfButtonProps === void 0 ? void 0 : infoPdfButtonProps.text) && (React.createElement(React.Fragment, null,
                    React.createElement(Button, { ...infoPdfButtonProps }),
                    React.createElement(Separator, { spacing: "xsmall", color: "invisible" }))),
                React.createElement(Grid, { reverse: buttonGridProps === null || buttonGridProps === void 0 ? void 0 : buttonGridProps.reverse, align: (buttonGridProps === null || buttonGridProps === void 0 ? void 0 : buttonGridProps.align) || (backButtonProps && ['between-xs']) || ['start-xs'] },
                    React.createElement(GridColumn, { width: (buttonGridColumnProps === null || buttonGridColumnProps === void 0 ? void 0 : buttonGridColumnProps.width) || ['xs'] },
                        React.createElement(SubmitButton, { form: form, showLoading: submitting, ...submitButtonProps })),
                    !!backButtonProps && (React.createElement(GridColumn, { width: (buttonGridColumnProps === null || buttonGridColumnProps === void 0 ? void 0 : buttonGridColumnProps.width) || ['xs'] },
                        React.createElement(AnalyticsTrigger, { trigger: { id: `Link - ${form.title} - Cancel`, callback: 'onClick' } },
                            React.createElement(Button, { ...backButtonProps })))))));
        }
        wrapInGrid(form) {
            return (React.createElement(Grid, null,
                React.createElement(GridColumn, { ...this.props.gridColumnProps }, form)));
        }
        render() {
            const { form, gridColumnProps, currentLanguage } = this.props;
            let formJsx = (React.createElement("div", { className: "form", id: `form-${form.id}` },
                this.renderHeader(),
                this.renderFailureNotice(),
                this.renderFields()));
            formJsx = gridColumnProps ? this.wrapInGrid(formJsx) : formJsx;
            return (React.createElement(AnalyticsProvider, { group: "Form" },
                React.createElement(FieldValidationErrorNotice, { inFormHeader: true }),
                React.createElement("form", { onSubmit: this.handleFormSubmit, ref: this.props.setRef, noValidate: true },
                    formJsx,
                    React.createElement(Separator, { spacing: "small", color: "invisible" }),
                    React.createElement(Captcha, { ref: this.captchaRef, currentLanguage: currentLanguage }),
                    this.renderButtons())));
        }
    };
    __setFunctionName(_classThis, "Form");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        Form = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return Form = _classThis;
})();
export default inject('translateStore')(Form);
//# sourceMappingURL=Form.js.map